import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: 'rms-search-certification-type',
  templateUrl: './search-certification-type.component.html',
  styleUrls: ['./search-certification-type.component.css']
})
export class SearchCertificationTypeComponent {
  @Output() search = new EventEmitter<any>(); 

  formSearchGroup: FormGroup;
  isSearching: boolean = false;

  constructor(
    private _formBuilder: FormBuilder) {
      this.formSearchGroup = this._formBuilder.group({
        name: [""],
        code: [""]
      });
  }

  onKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onSearchClick();
    }
  }

  onSearchClick() {
    this.isSearching = true;
    let searchKeyValues = {
      "Name": this.formSearchGroup.get("name").value,
      "Code": this.formSearchGroup.get("code").value
    };
    this.search.emit(searchKeyValues);
  }

  onSearchComplete() {
    this.isSearching = false;
  }

}